import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Retiring from './icon-retiring.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Retiring {...validProps} />;
}
SvgComponent.iconName = 'retiring';

export const RetiringIcon = svgIconWrapper(SvgComponent);
